import React, { useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Button, Checkbox, Image } from "antd-mobile";
import { AddCircleOutline, RightOutline } from "antd-mobile-icons";
import useRouter from "@/hooks/useRouter";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/redux/store";
import { isEmpty } from "lodash";
import { setUserManage } from "@/redux/reducers/manageUser";
import useCustomTranslation from "@/hooks/useTranslation";

const ManageRights: React.FC<{
	onVisiblePopup: (visible: boolean) => void;
	onSubmit: (data: string[]) => void;
}> = ({ onVisiblePopup, onSubmit }) => {
	const classes = useStyles();
	const dispatch: AppDispatch = useDispatch();
	const { t } = useCustomTranslation();
	const { customNavigate } = useRouter();
	const userManage = useSelector(
		(state: RootState) => state.manageUser.userManage
	);
	const [value, setValue] = useState(["look"]);
	// @Schema(title = "充值和代存")
	// public Integer rechargeAndWithdraw;
	// @Schema(title = "备注和代存")
	// public Integer remakeAndDeposit;
	// @Schema(title = "查看权限")
	// public Integer look;
	return (
		<div className={classes.manageNumbers}>
			<header>
				<div
					className="closeIcon"
					onClick={() => {
						onVisiblePopup(false);
					}}
				>
					<Image
						src={require("@/assets/images/icons/back.png")}
						width={20}
						height={18}
					/>
				</div>
				<p>{t("ManageRights")}</p>
				<div
					className="determine"
					onClick={() => {
						dispatch(setUserManage({}));
						onSubmit(value);
						onVisiblePopup(false);
					}}
				>
					{t("Save")}
				</div>
			</header>
			<div
				style={{
					flex: 1,
					overflowY: "auto",
				}}
			>
				{isEmpty(userManage) ? (
					<div
						onClick={() => {
							onVisiblePopup(false);
							customNavigate("/add-members");
						}}
						className="selectAdd"
					>
						<AddCircleOutline fontSize={34} color="#4C66C7" />
						<p>{t("PSelectAddressMembers")}</p>
						<RightOutline fontSize={24} color="#4C66C7" />
					</div>
				) : (
					<div className="infoRights">
						<div className="user">
							<Image
								src={require("@/assets/images/icons/Avatar.png")}
								width={14}
								height={14}
							/>
							<span>{userManage.nickname || "-"}</span>
						</div>
						<div className="addr">
							<p>{userManage.walletAddress || "-"}</p>
						</div>
						<Image
							onClick={() => {
								onVisiblePopup(false);
								customNavigate("/add-members");
							}}
							className="uu"
							src={require("@/assets/images/icons/uu.png")}
							width={20}
							height={21}
						/>
					</div>
				)}
				<Checkbox.Group
					value={value}
					onChange={(v) => {
						setValue(v as string[]);
					}}
				>
					<ul>
						<li>
							<p>{t("RechargeProportional")}</p>
							<Checkbox value={"rechargeAndWithdraw"}></Checkbox>
						</li>
						<li>
							<p>{t("RemarkDeposit")}</p>
							<Checkbox value={"remakeAndDeposit"}></Checkbox>
						</li>
						<li>
							<p>{t("GoLookData")}</p>
							<Checkbox
								defaultChecked
								disabled
								value={"look"}
							></Checkbox>
						</li>
					</ul>
				</Checkbox.Group>
				<div
					onClick={() => {
						onVisiblePopup(false);
					}}
					className="cancel"
				>
					<Button
						block
						size="large"
						shape="rounded"
						style={{
							"--text-color": "#FFFFFF",
							"--border-width": "0",
							background:
								"linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
						}}
					>
						{t("Cancel")}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ManageRights;

const useStyles = createUseStyles({
	manageNumbers: {
		display: "flex",
		flexDirection: "column",
		height: "72vh",
		borderTopLeftRadius: pxToRem(10),
		borderTopRightRadius: pxToRem(10),
		backgroundColor: "#1E212A",
		"& .selectAdd": {
			display: "flex",
			alignItems: "center",
			height: pxToRem(72),
			padding: {
				left: pxToRem(20),
				right: pxToRem(20),
			},
			border: "1px solid #2F3A62",
			"& p": {
				flex: 1,
				overflow: "hidden",
				color: "#4C66C7",
				fontSize: pxToRem(16),
				fontWeight: "500",
				paddingLeft: pxToRem(26),
			},
		},
		"& .infoRights": {
			position: "relative",
			height: pxToRem(104),
			margin: {
				bottom: pxToRem(20),
				left: pxToRem(30),
				right: pxToRem(30),
			},
			padding: pxToRem(12),
			border: "1px solid #4C66C7",
			borderRadius: pxToRem(8),
			backgroundColor: "#181A22",
			"& .user": {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				width: pxToRem(92),
				height: pxToRem(24),
				padding: {
					left: pxToRem(6),
					right: pxToRem(6),
					top: pxToRem(5),
					bottom: pxToRem(5),
				},
				color: "#FFFFFF",
				fontSize: pxToRem(12),
				fontWeight: "500",
				borderRadius: pxToRem(6),
				backgroundColor: "#4C66C7",
				marginBottom: pxToRem(6),
				"& span": {
					paddingLeft: pxToRem(3),
				},
			},
			"& .addr": {
				width: pxToRem(214),
				color: "#F7F9FF",
				fontSize: pxToRem(16),
				fontWeight: "500",
				lineHeight: pxToRem(24),
				wordBreak: "break-word",
			},
			"& .uu": {
				position: "absolute",
				right: pxToRem(22),
				bottom: pxToRem(16),
			},
		},
		"& header": {
			position: "relative",
			height: pxToRem(58),
			lineHeight: pxToRem(58),
			textAlign: "center",
			fontSize: pxToRem(15),
			color: "#FFFFFF",
			"& .closeIcon": {
				position: "absolute",
				top: "50%",
				left: pxToRem(15),
				transform: "translateY(-50%)",
			},
			"& .determine": {
				position: "absolute",
				top: "50%",
				right: pxToRem(14),
				color: "#4B6DE3",
				transform: "translateY(-50%)",
			},
		},
		"& ul": {
			"& >li": {
				height: pxToRem(68),
				display: "flex",
				alignItems: "center",
				padding: {
					left: pxToRem(20),
					right: pxToRem(30),
				},
				justifyContent: "space-between",
				borderBottom: "1px solid #2F3A62",
				"& p": {
					flex: 1,
					fontSize: pxToRem(14),
					fontWeight: "400",
					color: "#FFFFFF",
					overflow: "hidden",
				},
			},
		},
		"& .cancel": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			height: pxToRem(88),
			color: "#FF6161",
			fontSize: pxToRem(18),
			fontWeight: "500",
			padding: {
				left: pxToRem(32),
				right: pxToRem(32),
			},
		},
	},
});
